import { ClaimStatus } from '../constants/ClaimStatus';

export enum ClaimType {
  CHARITY = 'CHARITY',
  BUSINESS = 'BUSINESS'
}

export class Claim {
  id?: string;
  userId!: string;
  charityId?: string;
  businessId?: string;
  organizationName!: string;
  email!: string;
  phone!: string;
  contact!: string;
  ein!: string;
  street!: string;
  city!: string;
  state!: string;
  zip!: string;
  website!: string;
  fileUrls?: string[];
  status!: ClaimStatus;
  claimType!: ClaimType;
  createdAt?: Date;
  approvedAt?: Date;
}
